import { useState } from "react"
import { createPortal } from "react-dom"
import { toast } from "react-toastify"
import classNames from "classnames"

import { useLazyPostAlertAcknowledgeQuery } from "store/api/alertsApi"
import { ApiTypes } from "types"
import { ReactComponent as IconAcknowledge } from "assets/svg/icon-modal-acknowledge.svg"

import { ModalLayout } from "layouts/ModalLayout"

import styles from "./index.module.scss"

interface Props {
  onCancel: () => void
  onSuccess: () => void
  currentAlerts: ApiTypes.Model.Alert[]
}

export const AlertsAcknowledgeModal = ({ onCancel, onSuccess, currentAlerts }: Props) => {
  const [triggerAlertAcknowledge, { isFetching }] = useLazyPostAlertAcknowledgeQuery()

  const [period, setPeriod] = useState("6h")

  const onSubmit = async (event: React.FormEvent<HTMLElement>) => {
    event.preventDefault()

    try {
      await triggerAlertAcknowledge({
        ids: currentAlerts.map(alert => alert.id),
        until: period,
      })

      toast.success("Alert has been successfully acknowledged!")
      onSuccess?.()
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      {createPortal(
        <ModalLayout width="450px" isFetching={isFetching} onConfirm={onSubmit} onCancel={onCancel}>
          <div className={classNames(styles.modalContent, styles.center)}>
            <IconAcknowledge />
            <h3 className={styles.modalTitle}>Acknowledge</h3>
            <div className={styles.modalMessage}>
              Please choose the duration for which the alert will stay in the acknowledged status. During this time,
              alerts on the device will be temporarily paused.
            </div>
            <div className={styles.separator} />
            <div className={styles.periodButtonsWrapper}>
              <span
                className={classNames(styles.periodButton, { [styles.active]: period === "6h" })}
                onClick={() => setPeriod("6h")}
              >
                6 hr
              </span>
              <span
                className={classNames(styles.periodButton, { [styles.active]: period === "12h" })}
                onClick={() => setPeriod("12h")}
              >
                12 hr
              </span>
              <span
                className={classNames(styles.periodButton, { [styles.active]: period === "1d" })}
                onClick={() => setPeriod("1d")}
              >
                1 day
              </span>
              <span
                className={classNames(styles.periodButton, { [styles.active]: period === "3d" })}
                onClick={() => setPeriod("3d")}
              >
                3 days
              </span>
            </div>
          </div>
        </ModalLayout>,
        document.body,
      )}
    </>
  )
}
